import assign from 'lodash/assign'
import isObject from 'lodash/isObject'
import * as regexp from '../utils/regexp'
import * as validator from '../utils/validator'

// element ui 所需的一些校验规则 https://github.com/yiminghe/async-validator

export let id_number_validator = (message = '身份证号格式错误') => {
  return (rule, value, callback) => {
    callback((value && !validator.id_number(value)) ? message : undefined)
  }
}
export let date_validator = (message = '日期格式错误') => {
  return (rule, value, callback) => {
    callback((value && !validator.date(value)) ? message : undefined)
  }
}
export let year_validator = (message = '年份格式错误') => {
  return (rule, value, callback) => {
    callback((value && !validator.year(value)) ? message : undefined)
  }
}

export let required = (message = '必填项', trigger = 'blur,change') => {
  if (isObject(message)) return assign({required: true}, message)
  return {required: true, message, trigger}
}
export let number = (message = '必须为数字', trigger = 'blur,change') => {
  return {type: 'number', message, trigger}
}
export let student_number = (message = '学生学号为 3 ~ 10 位数字', trigger = 'blur,change') => {
  return {pattern: regexp.student_number(), message, trigger}
}
export let name = (message = '姓名包含非法字符', trigger = 'blur,change') => {
  return {pattern: regexp.name(), message, trigger}
}
export let id_number = (message = '身份证号格式错误', trigger = 'blur,change') => {
  return {validator: id_number_validator(message), trigger: trigger}
}
export let date = (message = '日期格式错误', trigger = 'blur,change') => {
  return {validator: date_validator(message), trigger: trigger}
}
export let year = (message = '年份格式错误', trigger = 'blur,change') => {
  return {validator: year_validator(message), trigger: trigger}
}
export let phone = (message = '手机号格式错误', trigger = 'blur,change') => {
  return {pattern: regexp.phone(), message, trigger}
}
// 为了保证系统里每个地方的email校验逻辑一致，先没用 type: 'email'，统一用了正则
export let email = (message = '邮箱格式错误', trigger = 'blur,change') => {
  return {pattern: regexp.email(), message, trigger}
}
export let zip_code = (message = '邮政编码必须为6位数字', trigger = 'blur,change') => {
  return {pattern: regexp.zip_code(), message, trigger}
}
export let url = (message = '必须为合法的网址', trigger = 'blur,change') => {
  return {type: regexp.url(), message, trigger}
}



// WEBPACK FOOTER //
// ./src/common/rules.js